const BookingFlowDesktopLayout = ({
  is_center = false,
  children,
}: React.PropsWithChildren<{ is_center?: boolean }>) => {
  return (
    <div className="bg-[#FCFDFD] w-[100vw] h-[100vh] overflow-auto flex absolute inset-0 pt-[8rem]">
      <div className="min-h-[61.2rem] w-[84.2rem] border border-[#CBD5E1] rounded-[2rem] m-auto p-[2.4rem] flex flex-row">
        {is_center ? (
          <div className="w-full m-auto max-w-[50%]">{children}</div>
        ) : (
          children
        )}
      </div>
    </div>
  );
};

export default BookingFlowDesktopLayout;
